import {MobileWebviewCommunicationActionType, MobileWebviewCommunicationActions, isTwoWayCommunicationAction} from '@colonist/mobile'
import {socket, uiGameManager} from '../../../shared/scripts/EntryShared'
import {uiManager} from '../EntryMobile'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {TurnState} from '@colonist/game-states'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {TimeoutId} from '@colonist/types'
import {GameStateEnums} from '../../../../shared/GameEnums'
import {resizeUIGame} from '@colonist/ui-game'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'

// Jan 31, 2023. Mau. This is the key that the mobile app uses to send messages to the webview. We cannot change this key.
const REACT_NATIVE_WEBVIEW_EVENT_KEY = 'message'

export class UIMMobileWebviewCommunication {
    private static trackingTimeout: TimeoutId | undefined
    constructor() {
        document.addEventListener(REACT_NATIVE_WEBVIEW_EVENT_KEY, (event: MessageEvent) => {
            const message = event.data
            const eventName = message?.event ?? message
            const payload = message?.payload ?? ''

            if(!isTwoWayCommunicationAction(eventName)) return
            UIMMobileWebviewCommunication.mobileMessageHandler(eventName, payload)
        })

        UIMDeviceHandler.sendEventsOnAppLoad()
    }

    static sendPayloadToMobile<T extends MobileWebviewCommunicationActions>(event: T, data?: MobileWebviewCommunicationActionType<T>) {
        if(typeof (window as any)?.ReactNativeWebView?.postMessage == 'function') {
            (window as any).ReactNativeWebView.postMessage(JSON.stringify({event: event, data: data ?? 'default'}))
        }
    }

    static mobileMessageHandler(event: MobileWebviewCommunicationActions, payload?: MobileWebviewCommunicationActionType<MobileWebviewCommunicationActions>) {
        switch(event) {
            case MobileWebviewCommunicationActions.AppBackground:
                uiManager.mainpageController.bodyController.lobbyController.hide()
                uiGameManager?.eventController.sendEvent(false, GameStateEnums.UIGameEventEnums.GameVisibilityUpdated)
                break
            case MobileWebviewCommunicationActions.Resize:
                if(uiGameManager == undefined) return
                uiGameManager.canvasController.responsiveController.resizeScreen()
                resizeUIGame()
                setTimeout(() => {
                    uiGameManager.canvasController.responsiveController.resizeScreen()
                    resizeUIGame()
                }, 500)
                break
            case MobileWebviewCommunicationActions.AppForeground:
                uiManager.mainpageController.bodyController.lobbyController.show()
                const isUserInGameEndScreen = uiGameManager?.gameController?.currentState?.turnState == TurnState.GameEnd
                if(isUserInGameEndScreen) window.location.hash = ''

                socket?.controller.sender.sendNoop() // check connection is alive
                uiGameManager?.eventController.sendEvent(true, GameStateEnums.UIGameEventEnums.GameVisibilityUpdated)

                clearTimeout(this.trackingTimeout)
                this.trackingTimeout = setTimeout(() => {
                    if(socket?.controller.isSocketOpen()) return

                    const userStillDisconnected: AjaxDataTypes.AnalyticData = {
                        type: AnalyticEventType.MobileGameUserLeftGame,
                        category: AnalyticEventCategory.MobileAnalytics,
                        stringValue: 'disconnect-foreground',
                    }
                    void CA.sendAnalyticEventsWithMobileDimensions(userStillDisconnected)
                }, 5000)
                break
            case MobileWebviewCommunicationActions.AppEncounteredError:
                uiManager.loginController.removeLoading()
                break
            case MobileWebviewCommunicationActions.LocalizedPricingSubscriptions:
                if(payload == undefined) return
                StorageWrapper.setLocalizedStoreSubscriptionData(payload as MobileWebviewCommunicationActionType<MobileWebviewCommunicationActions.LocalizedPricingSubscriptions>)
                break
            case MobileWebviewCommunicationActions.LocalizedPricingProducts:
                if(payload == undefined) return
                StorageWrapper.setLocalizedStoreProductData(payload as MobileWebviewCommunicationActionType<MobileWebviewCommunicationActions.LocalizedPricingProducts>)
                break
            default:
                break
        }
    }
}
